import { render, staticRenderFns } from "./ArchiveComponent.vue?vue&type=template&id=2c3b9806&scoped=true"
import script from "./ArchiveComponent.vue?vue&type=script&lang=js"
export * from "./ArchiveComponent.vue?vue&type=script&lang=js"
import style0 from "./ArchiveComponent.vue?vue&type=style&index=0&id=2c3b9806&prod&scoped=true&lang=css"
import style1 from "./ArchiveComponent.vue?vue&type=style&index=1&id=2c3b9806&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b9806",
  null
  
)

export default component.exports